import React, { useState, useEffect } from "react";
import { validateAngkaTitik } from "./validationInput";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function InputText({
    labelTitle,
    labelStyle,
    type,
    containerStyle,
    defaultValue,
    placeholder,
    updateFormValue,
    updateType,
    isRequired,
    validateInput,
    maxLength,
    style,
    uppercase,
    idname,
    classname,
                       disabled = false,
    inputRef
}) {
    const [value, setValue] = useState(defaultValue);
    const [typePassword, setTypePassword] = useState('password');
    const [icon, setIcon] = useState(FaEye);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const updateInputValue = (val) => {
        if ((!validateInput || validateInput(val)) && (!maxLength || val.length <= maxLength)) {
            setValue(val);
            updateFormValue({ updateType, value: val });
        }
    };

    const handleToggle = () => {
        if (typePassword === 'password') {
            setIcon(FaEyeSlash);
            setTypePassword('text');
        } else {
            setIcon(FaEye);
            setTypePassword('password');
        }
    };

    const handleChange = (e) => {
        let newValue = uppercase ? e.target.value.toUpperCase() : e.target.value;

        if (validateInput === validateAngkaTitik) {
            // Remove all commas from the input value
            newValue = newValue.replace(/,/g, '');

            // Remove all non-digit characters except the dot
            newValue = newValue.replace(/[^\d.]/g, '');

            // If there is already a dot present, allow only one dot
            if (newValue.includes('.')) {
                const parts = newValue.split('.');
                newValue = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
            }

            // Remove leading zeros except if followed by a dot
            newValue = newValue.replace(/^0+(?!\.)/, '');

            // Add leading zero if input starts with a dot
            if (newValue.startsWith('.')) {
                newValue = '0' + newValue;
            }

            // Format number to have two decimal places
            if (newValue.includes('.')) {
                const decimalPart = newValue.split('.')[1];
                newValue = newValue.split('.')[0] + '.' + decimalPart.slice(0, 2);
            }

            // Add commas as thousand separators
            const parts = newValue.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            newValue = parts.join('.');
        }

        updateInputValue(newValue);
    };

    return (
        <div className={`w-full ${containerStyle}`}>
            {labelTitle && (
                <label className={`label mt ${labelStyle}`}>
                    <span className={`label-text text-base-content ${labelStyle}`}>
                        {labelTitle}
                        {isRequired && (
                            <span className={`fillout-required-asterisk ${labelStyle}`} style={{ color: "rgb(248, 113, 113)" }}> *</span>
                        )}
                    </span>
                </label>
            )}
            {type === 'password' ? (
                <div className="mb-2 flex items-center relative">
                    <input
                        ref={inputRef}
                        id={idname}
                        type={typePassword}
                        value={value || ""}
                        placeholder={placeholder || ""}
                        onChange={handleChange}
                        className={`input input-bordered w-full pr-10 ${classname}`}
                        maxLength={maxLength}
                        style={style}
                        disabled={disabled}
                    />
                    <span className="absolute inset-y-0 right-0 flex items-center px-3" onClick={handleToggle}>
                        {icon}
                    </span>
                </div>
            ) : (
                <input
                    ref={inputRef}
                    id={idname}
                    type={type || "text"}
                    value={value || ""}
                    placeholder={placeholder || ""}
                    onChange={handleChange}
                    className={`input input-bordered w-full ${classname}`}
                    maxLength={maxLength}
                    style={style}
                    disabled={disabled}
                />
            )}
        </div>
    );
}

export default InputText;
